import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  Flex,
  Heading,
  Box,
  Text,
  UnorderedList,
  ListItem,
  SimpleGrid,
  Grid
} from "@chakra-ui/react";

import { useLocation } from "react-router-dom";
import { Waypoint } from "react-waypoint";

//images
import bg from "../../assets/images/Logobg.jpeg";
import CaseStudiesWork from "../CaseStudies/CaseStudiesWork.js";
import CaseStudyCard from "../CaseStudies/CaseStudyCard.jsx";



const CaseStudies = () => {
  let params = useLocation();
  useEffect(() => {
    if (params?.state?.id)
      document.querySelector(`${params.state.id}`).scrollIntoView(true);
    else window.scrollTo(0, 0);
  }, [params.state, useLocation().state]);

  return (
    <Flex flexDir={"column"} alignItems={"center"}>
      <Helmet>
        <html lang="en" />

        <title>
          Engineering Case Studies | Flow Assurance & Process Engineering
        </title>

        <meta
          name="description"
          content="Review engineering case studies covering multiphase flow analysis, surge studies, hydrate management, wax deposition analysis, process simulation, and production system optimization."
        />

        <meta
          name="keywords"
          content="Engineering Case Studies, Flow Assurance Case Study, Process Engineering Study, OLGA Case Study, PIPESIM Analysis, Hydrate Study, Surge Analysis, Process Simulation"
        />

        <meta name="author" content="AKIA Flow Assurance" />
        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="Engineering Case Studies | AKIA Flow Assurance"
        />

        <meta
          property="og:description"
          content="Real-world engineering studies in flow assurance, process simulation, hydraulics, and transient analysis."
        />

        <link
          rel="canonical"
          href="https://akiaflowassurance.com/CaseStudies"
        />
      </Helmet>
      <Flex
        bg={`linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)), url(${bg})`}
        backgroundSize={"cover"}
        backgroundPosition={"bottom"}
        h={"100vh"}
        w="100vw"

        minH="100vh"
        color={"whiteAlpha.900"}


        align="center"        // vertical center ✅
        justify="center"      // horizontal center ✅
        px="2rem"
      >
        <Box
          transform={{
            base: "",
            md: "translateX(-10vw)",
            lg: "translateX(-15vw)",
          }}
          px={"2rem"}
        >
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
          >
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain5").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="animateMain5">
                <Heading
                  fontSize={{ base: "3.7rem", "3sm": "4.5rem", lg: "5.0rem" }}
                  textTransform={"uppercase"}
                  fontFamily={"Roboto Condensed, Lato, Sans-serif"}
                  flexShrink={"0"}
                  w={"fit-content"}
                >
                  Case Studies
                </Heading>
                <Box
                  w={"100%"}
                  h={"100%"}
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                />
              </Flex>
            </Waypoint>
          </Flex>
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
            mt={"1rem"}
          >
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain6").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="animateMain6">
                <Text
                  textAlign={{ base: "justify", md: "left" }}
                  flexShrink={0}
                  fontSize={"1.8rem"}
                  maxW={"100rem"}
                  w={"fit-content"}
                >
                  Flow assurance and process engineering case studies covering real-world
                  engineering challenges and solutions.
                </Text>




                <Box
                  w={"100%"}
                  h={"100%"}
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                />

              </Flex>

            </Waypoint>



          </Flex>
        </Box>


      </Flex>

      <Flex
        py={"5rem"}
        px={{ base: "2rem", "3sm": "8rem" }}
        flexDirection={"column"}
        alignItems={"center"}
      >



        <SimpleGrid columns={[1, 1,1, 2]} textColor={"white"} spacing={10} mt={"3rem"} mb={"3rem"} maxW={{base: "100rem", lg: "150rem"}} >
          {CaseStudiesWork.map((study) => (
            <CaseStudyCard key={study.id} study={study} />
          ))}
        </SimpleGrid>




      </Flex>
   <Flex
        width={"100vw"}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDirection={{ base: "column", md: "row" }}
        py={"6rem"}
      >
        <Heading
          textTransform={"uppercase"}
          fontWeight={"700"}
          fontSize={{ base: "2.2rem", md: "2.5rem" }}
        >
          Connect with us
        </Heading>
        <Flex alignItems={"center"} mt={{ base: "2rem", md: "0" }}>
          <a
                      id="phone"
                      style={{ flex: "0 0 22%" }}
                      href="https://wa.me/+971501232838"
                    >
                      
                        <Heading fontSize={"4rem"}>
                          <i
                            className="fa-brands fa-square-whatsapp"
                            style={{ color: "green" }}
                          />
                        </Heading>
                        
                        
                      
                    </a>
             <a href="https://www.linkedin.com/company/akia-flow-assurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-linkedin"
            ></i>
          </a>

          <a href="https://www.youtube.com/@AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-youtube"
            ></i>
          </a>



          <a href="https://www.facebook.com/AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-facebook"
            ></i>
          </a>
          <a href="https://www.instagram.com/akiaflowassurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-instagram"
            ></i>
          </a>
        </Flex>
      </Flex>




    </Flex>
  );
};
export default CaseStudies;




